import React, { useState } from 'react';
import { OrderPopover } from '@components/common/OrderPopover';
import { StatusTag } from '@components/common/StatusTag';
import { Tooltip } from '@components/common/Tooltip';
import { Loading } from '@fourthwall/components';
import { useOrderTimelineEvents } from '../../../Order';
export const TableStatusTag = ({ orderId, status, onTooltipOpen, onTooltipClose, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { timelineEvents, isLoading } = useOrderTimelineEvents(orderId, { enabled: isOpen });
    const handleTooltipOpen = () => {
        setIsOpen(true);
        onTooltipOpen?.();
    };
    const handleTooltipClose = () => {
        setIsOpen(false);
        onTooltipClose?.();
    };
    if (!orderId) {
        return React.createElement(StatusTag, { status: status });
    }
    return (React.createElement(Tooltip, { placement: "bottom-start", size: "medium", onOpen: handleTooltipOpen, onClose: handleTooltipClose, content: React.createElement(Loading, { isLoading: isLoading, size: "medium" },
            React.createElement(OrderPopover, { events: isLoading ? undefined : timelineEvents })) },
        React.createElement(StatusTag, { status: status, hoverable: true })));
};
